export default __webpack_public_path__ + "static/10557-a53001389931bbaaa241f1da279f8e51.jpg";